<script setup lang="ts">
import { AppLinkButton } from '@libs/ui';

interface ReadMoreButtonProps {
  (eventName: 'click'): void;
}

const emit = defineEmits<ReadMoreButtonProps>();
</script>

<template>
  <div class="read-more-button">
    <AppLinkButton
      :text="$t('planner.read_more')"
      size="m"
      @click="emit('click')"
    />
  </div>
</template>

<style scoped lang="scss">
.read-more-button {
  --gradient-height: 40px;

  width: 100%;
  background: var(--color-white);
  padding-top: var(--spacing-12);
  position: relative;

  &:before {
    content: '';
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      var(--color-white)
    );
    height: var(--gradient-height);
    width: 100%;
    position: absolute;
    top: calc(var(--gradient-height) * -1);
    left: 0;
  }
}
</style>
